(function() {
  'use strict';

  /* Multiple sections that render product cards each include this
     script via asset_url, so it can execute more than once per page.
     Guard against double-registering the document-level click handler
     (would fire add-to-cart multiple times on a single click). Per-card
     image-nav binding is idempotent on its own. */
  if (window.__orwProductCardBootstrapped) return;
  window.__orwProductCardBootstrapped = true;

  function initCard(card) {
    var mainImg = card.querySelector('.orw-product-card__image');
    var prevBtn = card.querySelector('[data-orw-nav="prev"]');
    var nextBtn = card.querySelector('[data-orw-nav="next"]');

    if (!mainImg || !prevBtn || !nextBtn) return;

    var imagesAttr = card.getAttribute('data-orw-images');
    if (!imagesAttr) return;

    var images;
    try { images = JSON.parse(imagesAttr); } catch (e) { return; }
    if (!images || images.length < 2) return;

    var current = 0;
    var total = images.length;

    function updateButtons() {
      /* First image: prev disabled, next active */
      if (current === 0) {
        prevBtn.classList.add('orw-product-card__nav--disabled');
        nextBtn.classList.remove('orw-product-card__nav--disabled');
      }
      /* Last image: next disabled, prev active */
      else if (current === total - 1) {
        nextBtn.classList.add('orw-product-card__nav--disabled');
        prevBtn.classList.remove('orw-product-card__nav--disabled');
      }
      /* Middle: both active */
      else {
        prevBtn.classList.remove('orw-product-card__nav--disabled');
        nextBtn.classList.remove('orw-product-card__nav--disabled');
      }
    }

    function goTo(index) {
      if (index < 0 || index >= total || index === current) return;
      current = index;
      mainImg.src = images[current];
      updateButtons();
    }

    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      goTo(current - 1);
    });

    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      goTo(current + 1);
    });

    updateButtons();
  }

  /* ------------------------------------------------------------------
     Add-to-cart "+" button -- document-level delegated handler so
     every product card on every page (homepage, collection, cart,
     product) wires up the same way and dynamically rendered cards
     (e.g. cart drawer fetched HTML) work too.

     Flow:
       1. Click "+" inside a product card link
       2. preventDefault so the parent <a> doesn't navigate
       3. POST /cart/add.js with { items: [{ id, quantity: 1 }] }
       4. On success dispatch 'orw:cart:open' -- the existing
          ORWCartDrawer listens for that event, opens the right
          drawer, and re-fetches /cart.js so the new item shows.
     ------------------------------------------------------------------ */
  function bindAddToCart() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-orw-add-cart]');
      /* Product page Add to cart is handled by orw-product-main.js */
      if (!btn || btn.closest('.orw-product-main')) return;

      e.preventDefault();
      e.stopPropagation();

      if (btn.hasAttribute('aria-busy')) return; /* in-flight */

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('disabled', '');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Add to cart failed: ' + r.status);
        return r.json();
      })
      .then(function() {
        document.dispatchEvent(new CustomEvent('orw:cart:open'));
      })
      .catch(function(err) {
        console.error('[ORW] Add to cart error:', err);
      })
      .then(function() {
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('disabled');
      });
    });
  }

  /* ------------------------------------------------------------------
     Wishlist heart -- document-level delegated handler so every product
     card on every page (homepage, collection, cart, product, search)
     toggles wishlist state. Storage is shared with the wishlist page
     via localStorage key 'orw_wishlist'. Active hearts get the --active
     class which the CSS paints red and keeps visible on desktop too.
     ------------------------------------------------------------------ */
  var WISHLIST_KEY = 'orw_wishlist';
  var ACTIVE_CLASS = 'orw-product-card__wishlist--active';

  function readWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) { /* quota or private mode -- silently ignore */ }
  }

  function handleFromCard(card) {
    var href = card && card.getAttribute('href');
    if (!href) return null;
    /* Card href is /products/<handle>?... -- strip path + query/hash. */
    var path = href.split('?')[0].split('#')[0];
    return path.replace(/^\/products\//, '').replace(/\/$/, '');
  }

  function syncAllHearts() {
    var saved = readWishlist();
    var btns = document.querySelectorAll('[data-orw-wishlist]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var card = btn.closest('[data-orw-card]');
      var handle = handleFromCard(card);
      if (!handle) continue;
      var on = saved.indexOf(handle) > -1;
      btn.classList.toggle(ACTIVE_CLASS, on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    }
  }

  function bindWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-orw-wishlist]');
      if (!btn) return;

      /* The button is inside the parent <a class="orw-product-card">,
         so prevent the link from following + don't bubble to image-nav. */
      e.preventDefault();
      e.stopPropagation();

      var card = btn.closest('[data-orw-card]');
      var handle = handleFromCard(card);
      if (!handle) return;

      var saved = readWishlist();
      var idx = saved.indexOf(handle);
      if (idx > -1) {
        saved.splice(idx, 1);
        btn.classList.remove(ACTIVE_CLASS);
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Add to wishlist');
      } else {
        saved.push(handle);
        btn.classList.add(ACTIVE_CLASS);
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      }
      writeWishlist(saved);

      /* Notify the wishlist page (if open in another tab) and any other
         listeners (header count badge, etc.). */
      document.dispatchEvent(new CustomEvent('orw:wishlist:change', {
        detail: { handle: handle, saved: saved }
      }));
    });

    /* Cross-tab sync: another tab removed/added a product, update hearts. */
    window.addEventListener('storage', function (e) {
      if (e.key === WISHLIST_KEY) syncAllHearts();
    });
  }

  /* Cards injected after load (e.g. cart recommendations) call this */
  window.ORWInitCards = function (root) {
    (root || document).querySelectorAll('[data-orw-card]').forEach(initCard);
    syncAllHearts();
  };

  function init() {
    document.querySelectorAll('[data-orw-card]').forEach(initCard);
    bindAddToCart();
    bindWishlist();
    syncAllHearts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
